import { confirm } from '@gitbook/spine-react';
import { useEventCallback } from '@gitbook/util-react-hooks';

import { useUpgrade } from '../../state';
import { DocumentationLink } from '../Link';

/**
 * Show a dialog when the user needs to upgrade to use reusable content.
 */
export function useReusableContentDisclaimer() {
    const upgrade = useUpgrade('reusable-content');
    return useEventCallback(
        ({
            mode,
            callback,
        }: {
            mode: 'create' | 'turnInto';
            callback: () => void | Promise<void>;
        }) => {
            if (!upgrade) {
                return callback();
            }

            void confirm({
                title: (
                    <div className="flex items-center gap-2">
                        {mode === 'create'
                            ? 'Create reusable content'
                            : 'Turn into reusable content'}
                    </div>
                ),
                children: (
                    <div className="flex flex-col gap-2 text-secondary text-ui-base">
                        <p>
                            Reusable content is a powerful way of sharing the same content across
                            multiple pages in your space.{' '}
                            <DocumentationLink path="content-editor/blocks/reusable-content">
                                Learn more.
                            </DocumentationLink>
                        </p>
                        <p className="text-secondary text-ui-base">
                            Reusable content is a Pro feature, upgrade your plan to get started.
                        </p>
                    </div>
                ),
                kind: 'upgrade',
                confirmLabel: upgrade.label,
                onCancel: () => {
                    //
                },
                onConfirm: async () => {
                    await upgrade.onPress();
                },
            });
        }
    );
}
